<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="height: unset" @click.stop>
                <!-- ダイアログのタイトル -->
                <div class="dialog-title" v-t="'message.title_url_qr_buddycom_call_easy_login'"></div>
                <hr class="dialog-hr">

                <div class="dialog-body">
                    <table width=100% height=100% cellpadding=0 cellspacing=0>
                        <div style="padding-left: 20px; padding-top: 10px; padding-bottom: 10px;">
                            <span style="color: #d55169; font-size: 150%; font-weight: bold;"
                                v-t="'message.info_easy_login_tenantlink'"></span>
                        </div>
                        <!-- かんたんログインURL -->
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.item_option_easyLogin_URL'">
                                        </div>
                                    </div>
                                </div>
                                <el-form style="padding: 20px 20px 0px;" :inline="true">
                                    <!-- URL -->
                                    <el-form-item>
                                        <el-input style="width: 650px;" id="easyLoginURL" size="large" type="text"
                                            v-model="this.easyLoginURL" />
                                    </el-form-item>
                                    <!-- コピーボタン -->
                                    <el-form-item>
                                        <el-button style="vertical-align:middle" @click="copyEasyLoginURL()"
                                            v-t="'message.item_copy'" />
                                    </el-form-item>
                                    <!-- URLを再発行するボタン -->
                                    <el-form-item>
                                        <el-popconfirm :title="$t('message.info_refresh_easy_login_url')"
                                            :confirmButtonText="$t('message.button_yes')"
                                            :cancelButtonText="$t('message.button_no')" icon="el-icon-info"
                                            iconColor="red" @confirm="refreshEasyLoginURL()">
                                            <template #reference>
                                                <el-button style="vertical-align:middle" native-type="button" v-t="'message.item_refresh_url'" />
                                            </template>
                                        </el-popconfirm>
                                    </el-form-item>
                                </el-form>
                            </td>
                        </tr>
                        <!-- かんたんログインQRコードの表示 -->
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.item_option_easyLogin_QR'">
                                        </div>
                                    </div>
                                </div>
                                <VueQrCode v-if="easyLoginURL != null" :value="easyLoginURL" :options="qrOption"
                                    tag="img"></VueQrCode>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')"
                        v-t="'message.button_back'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from '../commonutil.js'
import constants from '../constants.js';
import server from "../ServerApi.js";
import VueQrCode from '@chenfengyuan/vue-qrcode';

export default {
    components: {
        VueQrCode
    },

    props: ['appData', 'talkgroupAttribute'],

    data() {
        return {
            easyLoginURL: null,
            qrOption: {
                errorCorrectionLevel: "L",
                maskPattern: 0,
                margin: 10,
                scale: 2,
                width: 300,
                color: {
                    dark: "#000000FF",
                    light: "#FFFFFFFF",
                },
            },
        };
    },

    created: function () {
        if (this.talkgroupAttribute == null) {
            return
        }
        this.easyLoginURL = this.convertToBuddycomCallLoginURL(this.talkgroupAttribute.easyLoginURL)
    },

    methods: {
        copyEasyLoginURL() {
            navigator.clipboard
                .writeText(this.easyLoginURL)
                .then(() => {
                    commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_copied"));
                })
                .catch(e => {
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "item_failed"));
                })
        },
        /**
         * * コール用のURLに変換する
         * * 例: https://buddycom.net/a/1/... → https://buddycom.net/c/1/...
         * *
         * * @param {string} url - 元のEasyLogin URL
         * * @returns {string|null} 書き換え後のURL。無効なURLなら元の文字列またはnull
         * */
        convertToBuddycomCallLoginURL(url) {
            if (!url) {
                return null
            }

            try {
                const parsed = new URL(url);
                const segments = parsed.pathname.split('/')

                if (segments.length >= 3) {
                    segments[1] = 'c'
                }
                parsed.pathname = segments.join('/')
                return parsed.toString()
            } catch {
                return url
            }
        },
        async refreshEasyLoginURL() {
            let input = { talkgroupId: this.talkgroupAttribute.id }
            try {
                const res = await server.post('/refresheasyloginurl', input)
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.talkgroupAttribute.easyLoginURL = res.data.easyLoginURL
                        this.easyLoginURL = this.convertToBuddycomCallLoginURL(res.data.easyLoginURL)
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "item_refresh_url_done"))
                        break
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "refreshEasyLoginURL").replace("{code}", res.data.status))
                        return
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "refreshEasyLoginURL", error);
            }
        },
    }
}
</script>

<style scoped></style>
